/**
 * zhaoy
 * 学生到校
 */
import React, { Component } from 'react'
import { Card, Progress } from 'antd'
import { LeftOutlined, RightOutlined } from '@ant-design/icons';
import './DormitorySchool.css';
import ClassBean from '../../model/ClassBean'
import { Toast, Picker, List, DatePicker } from 'antd-mobile';
import { connect } from 'react-redux'
import { changeTabIndex } from "../../redux/actions/action"
import * as echarts from 'echarts/core';
import { TooltipComponent, LegendComponent } from 'echarts/components';
import { PieChart } from 'echarts/charts';
import { CanvasRenderer } from 'echarts/renderers';
import { fetchGet, fetchPost } from "../../utils/fetchRequest";
import { API } from "../../configs/api.config";
import InOutBean from "../../model/InOutBean";
import DormitoryItem from '../../components/DormitoryItem';
import { getArrayValue, getIntValue, getStrValue, isObjEmpty } from "../../utils/common";

echarts.use([TooltipComponent, LegendComponent, PieChart, CanvasRenderer]);

class DormitorySchool extends Component {

    constructor(props) {
        super(props);
        this.state = {
            classList: [],
            classValue: [],
            albumList: [],
            lack: 0, //缺勤
            total: 0, //总数
            residence: 0, //住宿
            skaForLeave: 0, //请假
            clock: 0, //打卡
            startValue: new Date(),
        }
    }

    componentDidMount() {
        document.title = '考勤统计';
        if (this.props.userInfo.userRole === 2) {
            this.getClassList()
        }

    }

    timeChange(flag) {
        let time = this.state.startValue
        if (flag === "left") {
            time.setDate(time.getDate() - 1)
        } else {
            time.setDate((time.getDate() + 1) > new Date().getDate() ? new Date().getDate() : (time.getDate() + 1))
        }
        this.setState({
            startValue: new Date(time)
        })
    }

    render() {
        const {
            classList, classValue, albumList, lack, total, residence, skaForLeave, clock
        } = this.state;

        let albumItems = []
        if (!isObjEmpty(albumList)) {
            for (let i = 0; i < albumList.length; i++) {
                const albumBean = albumList[i]
                if (!isObjEmpty(albumBean)) {
                    albumItems.push(
                        <DormitoryItem
                            albumBean={albumBean}
                            itemClick={this.onRosterItemClick.bind(this)}
                            index={i}
                            key={albumBean.stu_id} />
                    )
                }
            }
        }
        return (<>

            <div className="customTimeComponent">
                <div className="leftButton" onClick={() => this.timeChange("left")}><LeftOutlined /></div>
                <div className="timeDisplay">{this.state.startValue.format("yyyy-MM-dd")}</div>
                <div className="rightButton" onClick={() => this.timeChange("right")}><RightOutlined /></div>
            </div>
            <Picker data={classList} title='选择班级' extra='请选择'
                value={classValue} onChange={this.handleClassChange} cols={1}>
                <List.Item arrow="horizontal">选择班级</List.Item>
            </Picker>
            {/*  <DatePicker
            value={this.state.startValue}
            locale={{
                okText: '确定',
                dismissText: '取消',
            }}
            onChange={date => this.setState({startValue: date})}>
            <List.Item arrow="horizontal">记录时间</List.Item>
        </DatePicker>*/}

            <div className='gray-line'></div>
            <div style={{ marginTop: 2, padding: 5 }}>
                <span style={{ fontSize: '12px', color: '#CD1D1D', width: '25%' }}>| <span style={{ fontSize: 12, color: "#999999" }}>入校统计</span></span>
            </div>
            <div id="main" style={{ width: '100%', height: 300, position: 'relative', padding: 5, borderRadius: 10 }}></div>

            <div className='gray-line'></div>

            {/* <div style={{backgroundColor:'#FFF',width:'100%',padding:5,borderRadius:10}} >111</div>*/}
            <span style={{ fontSize: '12px', color: '#CD1D1D', width: '25%', padding: 2 }}>| <span style={{ width: '98px' }}>出勤率</span></span>
            <span style={{ fontSize: '12px', color: '#999999', width: '25%', display: 'block' }}>考勤率：</span><Progress percent={100} status="active" style={{ width: '98%' }} />
            <span style={{ fontSize: '12px', color: '#999999', width: '25%' }}>已签到：<Progress percent={Math.round(clock / total * 1000) / 10} status="active" style={{ width: '98%' }} /></span>
            <span style={{ fontSize: '12px', color: '#999999', width: '25%' }}>已请假：<Progress percent={Math.round(skaForLeave / total * 1000) / 10} status="active" style={{ width: '98%' }} /></span>
            <span style={{ fontSize: '12px', color: '#999999', width: '25%' }}>住校：<Progress percent={Math.round(residence / total * 1000) / 10} status="active" style={{ width: '98%' }} /></span>
            <span style={{ fontSize: '12px', color: '#999999', width: '25%' }}>缺勤：<Progress percent={Math.round(lack / total * 1000) / 10} status="active" style={{ width: '98%' }} /></span>

            <div className='gray-line'></div>

            <div style={{ fontSize: '12px', color: '#CD1D1D', width: '25%', padding: 2 }}>| <span style={{ width: '100px' }}>考勤名单</span></div>
            {/*<div className="header_days_sty">
                <div className={'each_day_default'}>
                    姓名
                </div>
                <div className={'each_day_default'}>
                    班级
                </div>
                <div className={'each_day_default'}>
                    状态
                </div>
                <div className={'each_day_default'}>
                    签到
                </div>
            </div>*/}
            {albumItems}
        </>
        )
    }
    onRosterItemClick = (index) => {
    }

    analysisClassList = response => {
        const { classList, classValue } = this.state
        classList.length = 0
        classValue.length = 0

        let dataArray = response.data
        if (dataArray) {
            for (let i = 0; i < dataArray.length; i++) {
                let dataObject = dataArray[i]
                if (dataObject) {
                    let classBean = new ClassBean()

                    classBean.label = getStrValue(dataObject, 'clazzGrade') + getStrValue(dataObject, 'clazzName')
                    classBean.value = i
                    classBean.schId = getStrValue(dataObject, 'clazzId')
                    classBean.parentId = getStrValue(dataObject, 'gradeId')
                    classBean.schName = getStrValue(dataObject, 'clazzName')
                    classBean.schStatus = getStrValue(dataObject, 'clazzStatus')
                    classBean.schRemarks = getStrValue(dataObject, 'clazzRemarks')
                    classBean.grade = getStrValue(dataObject, 'clazzGrade')

                    classList.push(classBean)
                }
            }

            if (classList.length > 0) {
                classValue.push(classList[0].value)
                this.setState({
                    classList,
                    classValue
                })

                Toast.loading('考勤统计...', 0)
                this.getAlbumList(classList[0])
            }
        }
    }

    getClassList = () => {
        const { classList, classValue } = this.state
        classList.length = 0
        let userRole = this.props.userInfo.userRole;
        let params, url;

        url = API.GET_SCHOOL_CLASS_LIST
        params = {
            schoolId: this.props.userInfo.user.schoolId,
            teacherId: this.props.userInfo.user.userFunId,
            roleType: this.props.userInfo.teacher.roleType,
        }

        fetchGet(url, params).then(response => {
            Toast.hide()
            this.analysisClassList(response)
        }).catch(error => {
            Toast.hide()

            if (typeof error === 'string') {
                Toast.fail(error, 2)
            } else {
                Toast.fail('班级获取异常', 2)
            }
        })
    }

    handleClassChange = (v) => {
        this.setState({ classValue: v })
        if (v.length > 0) {
            this.getAlbumList(this.state.classList[v])
        }
    }

    getAlbumList = classBean => {

        const { startValue, lack, total, residence, skaForLeave, clock, albumList } = this.state

        fetchPost(API.GET_CLASS_ROSTER_LIST, {
            clazzId: classBean.schId,
            schoolId: this.props.userInfo.user.schoolId,
            startDate: startValue.format("yyyy-MM-dd"),
        }).then(response => {
            Toast.hide()

//            const rosterList = [];
            let dataArray = response.data
            let inOutBean = new InOutBean()
            if (dataArray) {
                inOutBean.lack = getIntValue(dataArray, 'lack')
                inOutBean.total = getIntValue(dataArray, 'total')
                inOutBean.skaForLeave = getIntValue(dataArray, 'skaForLeave')
                inOutBean.clock = getIntValue(dataArray, 'clock')
                inOutBean.residence = getIntValue(dataArray, 'residence')
                inOutBean.rosterList = getArrayValue(dataArray, 'studentList')
                /*for (let i = 0; i < dataArray.length; i++) {
                    let dataObject = dataArray[i] //list对象
                    if (dataObject) {
                        let inOutBean = new InOutBean()
                        inOutBean.lack = getIntValue(dataObject, 'lack')
                        inOutBean.total = getIntValue(dataObject, 'total')
                        inOutBean.skaForLeave = getIntValue(dataObject, 'skaForLeave')
                        inOutBean.clock = getIntValue(dataObject, 'clock')

                        rosterList.push(inOutBean)
                    }
                }*/

                var chartDom = document.getElementById('main');
                var myChart = echarts.init(chartDom);
                var option = {
                    tooltip: {
                        trigger: 'item'
                    },
                    legend: {
                        top: '1%',
                        right: '1%',
                        orient: 'vertical',
                        /*left: 'right',*/
                    },
                    series: [
                        {
                            name: '班级考勤',
                            type: 'pie',
                            radius: ['40%', '70%'],
                            avoidLabelOverlap: true,
                            label: {
                                show: true,
                                position: 'center'
                            },
                            emphasis: {
                                label: {
                                    show: true,
                                    fontSize: '40',
                                    fontWeight: 'bold'
                                }
                            },
                            labelLine: {
                                show: false
                            },
                            data: [
                                { value: inOutBean.total, name: '总人数:' + inOutBean.total },
                                { value: inOutBean.clock, name: '已签到:' + inOutBean.clock },
                                { value: inOutBean.skaForLeave, name: '已请假:' + inOutBean.skaForLeave },
                                { value: inOutBean.residence, name: '住校:' + inOutBean.residence },
                                { value: inOutBean.lack, name: '缺勤:' + inOutBean.lack }
                            ]
                        }
                    ]
                };

                myChart.setOption(option);
                this.setState({
                    albumList: inOutBean.rosterList,
                    total: inOutBean.total,
                    residence: inOutBean.residence,
                    clock: inOutBean.clock,
                    skaForLeave: inOutBean.skaForLeave,
                    lack: inOutBean.lack,

                })
            }
        }).catch(error => {
            Toast.hide()
            if (typeof error === 'string') {
                Toast.fail(error)
            }
        })
    }
}




let mapStateToProps = (state) => ({
    userInfo: { ...state.redUserInfo },
    listState: { ...state.redListState }
});

let mapDispatchToProps = (dispatch) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(DormitorySchool)
